import React from 'react';

const Header = () => {
  return (
    <header>
        <section>
            <a href="/"><img src='https://26159260.fs1.hubspotusercontent-eu1.net/hubfs/26159260/personalBlog/MINDSCAPEClogo.svg' /></a>
            <nav>
                <ul>
                {/* <li><a href="#">About</a></li> */}
                </ul>
            </nav>
        </section>
    </header>
  );
};

export default Header;
